import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BankVerificationInfoReducer } from '../reducers';

export const selectBankVerificationInfoFeature = createFeatureSelector<BankVerificationInfoReducer.BankVerificationInfoState>(
  BankVerificationInfoReducer.featureName
);

export const selectBankVerificationInfo = createSelector(selectBankVerificationInfoFeature, ({ items }) => items);
export const selectBankVerificationList = createSelector(selectBankVerificationInfoFeature, ({ list }) => list);
